import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 max-w-[1400px] mx-auto">
          <Link
            to="/"
            className="flex items-center gap-2 text-2xl font-heading whitespace-nowrap cursor-pointer no-underline"
            style={{ color: scrolled ? 'oklch(var(--primary-600))' : '#fff' }}
          >
            <i className="ri-play-circle-line text-3xl"></i>
            <span>芭乐视频</span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-3 py-2 rounded-lg text-sm whitespace-nowrap transition-all duration-200 cursor-pointer no-underline ${
                  location.pathname.includes(cat.slug)
                    ? 'bg-primary-500 text-white'
                    : scrolled
                      ? 'text-foreground-700 hover:bg-background-100'
                      : 'text-white/90 hover:bg-white/10'
                }`}
              >
                {cat.name}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/about"
              className={`text-sm whitespace-nowrap cursor-pointer no-underline transition-colors duration-200 ${
                scrolled ? 'text-foreground-600 hover:text-primary-600' : 'text-white/80 hover:text-white'
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer bg-transparent border-none"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="菜单"
          >
            <i
              className={`text-2xl transition-colors ${
                scrolled ? 'text-foreground-800' : 'text-white'
              } ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}
            ></i>
          </button>
        </div>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-3 flex flex-col gap-1">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-3 rounded-lg text-sm whitespace-nowrap cursor-pointer no-underline transition-colors ${
                  location.pathname.includes(cat.slug)
                    ? 'bg-primary-100 text-primary-700 font-medium'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                <i className={`${cat.icon} mr-2`}></i>
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className="px-4 py-3 rounded-lg text-sm whitespace-nowrap cursor-pointer no-underline text-foreground-700 hover:bg-background-100 mt-2 border-t border-background-200 pt-3"
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}